// test110
(110 && 0);
